import React from 'react'
import { Box, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material'
import { XMarkIcon } from '@heroicons/react/24/outline'
import { Button } from '../../../interaxDesignSystemComponents'
import { INTERAX_COLORS } from '../../../constants/colors'
import { useTranslation } from '../../hooks/useIntractionTranslate'

interface ModalProps {
  isOpen: boolean
  onClose: () => void
  title: string
  children: React.ReactNode
  actions?: React.ReactNode
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
  className?: string
}

export const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  title,
  children,
  actions,
  maxWidth = 'sm',
  className = ''
}) => {
  const { t } = useTranslation()

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      maxWidth={maxWidth}
      fullWidth
      className={className}
      PaperProps={{
        sx: {
          backgroundColor: INTERAX_COLORS.heritageBlue,
          border: `1px solid ${INTERAX_COLORS.thunderGrey}`,
          borderRadius: '12px'
        }
      }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '20px 24px 12px',
          borderBottom: `1px solid ${INTERAX_COLORS.thunderGrey}`,
          marginBottom: '16px'
        }}
      >
        <Box className="text-headline-4" sx={{ color: INTERAX_COLORS.white }}>
          {title}
        </Box>
        <Button
          variant="secondary"
          onClick={onClose}
          ariaLabel={t('common.close', 'Close')}
          icon={<XMarkIcon className="w-4 h-4" />}
          className="!p-0 !min-w-0 !h-8 !w-8 shrink-0"
        />
      </DialogTitle>

      <DialogContent sx={{ padding: '0 24px 16px' }}>{children}</DialogContent>

      {actions && <DialogActions sx={{ padding: '16px 24px 24px', gap: '12px' }}>{actions}</DialogActions>}
    </Dialog>
  )
}
